// extracted by mini-css-extract-plugin
export var stepActive = "_2t-3";
export var stepCompleted = "_2t-4";
export var stepConnectorLine = "_2t-b";
export var stepIndicatorCircle = "_2t-6";
export var stepIndicatorCircleCompleted = "_2t-7";
export var stepIndicatorCircleDefault = "_2t-8";
export var stepIndicatorTextCompleted = "_2t-9";
export var stepIndicatorTextDefault = "_2t-a";
export var stepPending = "_2t-5";
export var wizardContainer = "_2t-1";
export var wizardContent = "_2t-2";
export var wizardModal = "_2t-0";